module.exports = __webpack_public_path__ + "img/user.c03340b6.png";